import { render } from "./Stake.vue?vue&type=template&id=0ef07eb8"
import script from "./Stake.vue?vue&type=script&lang=js"
export * from "./Stake.vue?vue&type=script&lang=js"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__